import { FC } from 'react';
import { normalizeOutLink as normalizeLink, openLink } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import { useScreenType } from '@web3/base-hooks';
import { useHover } from '@/hooks/useHover';
import { Arrow } from '@/components/arrow';
import styles from './index.module.scss';
import { Event, Page } from '@/config/track-config';

export const Link: FC = () => {
  const { active, bind } = useHover();
  const { isMobile } = useScreenType();

  const navToSwap = () => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.Home,
      area: 'Swap',
      button_name: 'More',
      params: isMobile
        ? 'by://web3/tab/index?tag=swap'
        : normalizeLink('/web3/swap/market'),
    });
    if (isMobile) {
      openLink('by://web3/tab/index?tag=swap');
      return;
    }
    window.open(normalizeLink('/web3/swap/market'));
  };

  return (
    <div className={styles.action} {...bind} onClick={navToSwap}>
      <Arrow active={active} />
    </div>
  );
};

export default Link;
